// Success confirmation copy for the Player Finder preference flows. Single
// source of truth for the mobile SuccessBottomSheet title/subtitle. Remove has
// no success message (it confirms via the Alert dialog instead).
export const FINDER_SUCCESS_MESSAGES = {
  add: {
    title: 'Preference Added',
    subtitle: 'Teams looking for players can now find you for this sport.',
  },
  edit: {
    title: 'Changes Saved',
    subtitle: 'Your player finder profile has been updated.',
  },
} as const
